import React, { FunctionComponent } from "react";
import { useField } from "formik";
import NumberFormat, { NumberFormatProps, NumberFormatValues } from "react-number-format";

export interface Props extends NumberFormatProps {
  name: string;
  formatAsString?: boolean;
}

export const NumberField: FunctionComponent<Props> = ({ name, formatAsString, ...props }) => {
  const [{ value = "", onBlur }, , { setValue }] = useField(name);
  const handleChange = React.useCallback(
    (values: NumberFormatValues) => {
      if (formatAsString) {
        return setValue(values.floatValue?.toFixed(props.decimalScale || 2).toString());
      }
      return setValue(values.floatValue);
    },
    [setValue, props.decimalScale, formatAsString]
  );

  return (
    <NumberFormat
      id={name}
      name={name}
      value={value}
      onBlur={onBlur}
      onValueChange={handleChange}
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={"."}
      allowedDecimalSeparators={[",", "."]}
      {...props}
    />
  );
};

NumberField.displayName = "NumberField";
